<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import cep from 'cep-promise'
    const dispatch = createEventDispatcher()
    import { faAngleRight, faRotateLeft, faSave, faSearch, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc)
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import { Person } from '../../modules/eventsApi/persons/person'
    import type { PersonCreateDto } from '../../modules/eventsApi/persons/person-create.dto'
    import type { PersonUpdateDto } from '../../modules/eventsApi/persons/person-update.dto'
    import Content from '../_common/content.svelte'
    import { ReferralsRepository } from '../../modules/eventsApi/referrals/referrals.repository'
    import { ReferralsService } from '../../modules/eventsApi/referrals/referrals.service'
    import type { Referral } from '../../modules/eventsApi/referrals/referral'
    import Zexpand from '../_common/z/zexpand.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZinputBreak from '../_common/z/zinput-break.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import ZsheetSection from '../_common/z/sheet/zsheet-section.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import type { GridButton } from '../_common/z/zgrid'
    import type { CountryEntity } from '../../modules/eventsApi/countries/country.entity'
    // ##############################################################################################################

    const entityId = 'personId'
    let step = 0
    let expand: boolean = screen.width > 900

    const rep = new PersonsRepository()
    const service = new PersonsService(rep)

    const refR = new ReferralsRepository()
    const refS = new ReferralsService(refR)
    let referrals: Referral[] = []
    let phone: string = ''
    let show = false
    export let person: Person = new Person()

    let countries: CountryEntity[] = []
    async function loadCountries() {
        countries = await window.api.events.countries.getAll()
    }

    // ---- opções e pontes para os campos --------------------------------------------------------
    // o Zinput de select não cria opção vazia sozinho; "sem origem" e "sem país" precisam existir
    $: referralOptions = [{ value: '', label: '[sem origem]' }, ...referrals.map((el) => ({ value: el.referralId, label: el.label }))]
    $: countryOptions = [{ value: '', label: '' }, ...countries.map((el) => ({ value: el.name, label: el.name }))]

    const genderOptions = [
        { value: '', label: 'Selecione...' },
        { value: 'male', label: 'Masculino' },
        { value: 'female', label: 'Feminino' },
        { value: 'other', label: 'Outro' },
    ]

    // O Zinput de data trabalha com Date, mas a gravação usa o texto 'YYYY-MM-DD' (dateStringToCurrentDate)
    // e ainda trata ano com menos de 4 dígitos. Então a data do campo é a ponte, e `born` continua
    // sendo a verdade em texto — derivada, nunca editada à mão.
    let bornDate: Date = null
    $: born = bornDate instanceof Date && !isNaN(bornDate.getTime()) ? dayjs(bornDate).format('YYYY-MM-DD') : null

    // busca do CEP dentro do próprio campo, em vez de um botão colado ao lado
    const actBuscarCep: GridButton = { label: null, icon: faSearch, callback: () => searchAddress() }

    // primeira etapa do cadastro: o "Avançar" é a ação do próprio campo de telefone
    const actAvancar: GridButton = { label: 'Avançar', icon: faAngleRight, color: 'primary', callback: () => checkExists() }

    // O evento do teclado chega embrulhado: o input avisa o Zinput, que reemite o aviso. A tecla pode
    // estar no evento recebido ou em qualquer "detail" abaixo dele, por isso a busca desce a corrente.
    function teclaEnter(ev: any) {
        let atual = ev
        for (let nivel = 0; nivel < 4 && atual; nivel++) {
            if (atual.key === 'Enter') return true
            atual = atual.detail
        }
        return false
    }

    function onCepKeyup(ev) {
        if (teclaEnter(ev)) searchAddress()
    }

    // digitar o telefone e apertar Enter faz o mesmo que o "Avançar" do campo
    function onTelefoneKeyup(ev) {
        if (teclaEnter(ev)) checkExists()
    }

    // contatos como vieram do backend (podem estar mascarados) — só são reenviados se o usuário alterar
    let loadedContacts: { phone?: string; email?: string } = {}

    async function editEntity(id: string) {
        try {
            show = true
            step = 1
            person = new Person()
            person = await service.getOne(id)
            loadedContacts = { phone: person.phone, email: person.email }
            // o backend pode devolver ano com 3 dígitos; o texto é normalizado antes de virar data
            let bornText = person.born ? dayjs(person.born).utc().format('YYYY-MM-DD') : null
            if (bornText?.length === 7) bornText = '000' + bornText
            bornDate = bornText ? new Date(bornText + 'T00:00:00') : null
            if (person.name.startsWith('Pessoa ')) person.name = ''
            console.log('person', person)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function loadReferrals() {
        referrals = await refS.getAll()
    }

    function newEntity() {
        person = new Person()
        person.country = 'Brasil'
    }

    function cancelDuplicity() {
        phone = ''
        duplicity = ''
    }

    function allowDuplicity() {
        person.phone = phone
        step = 1
    }

    let duplicity = ''
    async function checkExists() {
        phone = phone.replace(/[^0-9+]/g, '')
        if (phone.length < 10) {
            evaluateError('Informe o telefone com DDD')
            return
        }
        let utils = window.api.utils.utils
        phone = utils.phoneNormalize(phone, '00')
        duplicity = ''
        let result = await service.getAll({ phones: phone })
        console.log('result', result, phone)
        if (result.length > 0) {
            // se é um registro iniciando com 'Pessoa ', abre para edição
            if (String(result[0].name).startsWith('Pessoa ')) {
                editEntity(result[0].personId)
                return
            }
            duplicity = result[0].name || result[0].phone
            return
        }
        person.phone = phone
        step = 1
    }

    async function createEntity() {
        try {
            if (show) return
            show = true
            let utcBorn: any = undefined
            if (born) {
                utcBorn = dayjs(window.api.utils.utils.dateStringToCurrentDate(born)).toISOString()
            }
            const dto: PersonCreateDto = {
                donotEmail: person.donotEmail,
                donotPhone: person.donotPhone,
                donotSms: person.donotSms,
                donotWA: person.donotWA,
                donotLogin: person.donotLogin,
                name: person.name,
                born: utcBorn,
                email: person.email,
                phone: person.phone,
                address: person.address,
                CEP: person.CEP,
                city: person.city,
                complement: person.complement,
                district: person.district,
                number: person.number,
                referralId: person.referralId,
                state: person.state,
                document: person.document,
                businessName: person.businessName,
                RG: person.RG,
                comments: person.comments,
                gender: person.gender,
                country: person.country,
                passport: person.passport,
            }
            if (!validateDto(dto)) return false
            console.log('create', dto, born)
            let pid = await service.create(dto, { allowPersonDuplicity: window.configs.allowPersonDuplicity })
            person = await service.getOne(pid.personId)
            window.api.utils.utils.removePersonFromCache(person.personId)
            window.api.users.statistics.tick('person.create')
            sendClose()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function validateDto(dto) {
        if (!dto.phone) {
            evaluateError('Informe o telefone')
            return false
        }
        if (dto.born === '') {
            //evaluateError('Verifique a data de nascimento')
            //return false
        }
        if (window.configs.personRegisterRequired && window.configs.personRegisterRequired.length > 0) {
            if (window.configs.personRegisterRequired.includes('e-mail') && (!dto.email || dto.email.includes('@') === false)) {
                evaluateError('Informe o e-mail')
                return false
            }
            if (window.configs.personRegisterRequired.includes('origem') && !dto.referralId) {
                evaluateError('Informe a origem da pessoa')
                return false
            }
        }
        return true
    }

    async function updateEntity() {
        try {
            show = true
            let utcBorn: any = undefined
            if (born) {
                utcBorn = dayjs(window.api.utils.utils.dateStringToCurrentDate(born)).toISOString()
                person.born = utcBorn
            }
            const dto: PersonUpdateDto = {
                donotEmail: person.donotEmail,
                donotPhone: person.donotPhone,
                donotSms: person.donotSms,
                donotWA: person.donotWA,
                donotLogin: person.donotLogin,
                name: person.name,
                born: utcBorn,
                email: person.email,
                phone: person.phone,
                address: person.address,
                CEP: person.CEP,
                city: person.city,
                complement: person.complement,
                district: person.district,
                number: person.number,
                referralId: person.referralId,
                state: person.state,
                document: person.document,
                RG: person.RG,
                comments: person.comments,
                gender: person.gender,
                country: person.country,
                passport: person.passport,
            }
            if (dto.email === loadedContacts.email) delete dto.email
            if (dto.phone === loadedContacts.phone) delete dto.phone
            console.log('update', dto, born)
            await service.update(person[entityId], dto, { allowPersonDuplicity: window.configs.allowPersonDuplicity })
            window.api.utils.utils.removePersonFromCache(person.personId)
            sendClose()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (person[entityId]) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function reactivateEntity() {
        if (!confirm('Deseja mesmo reativar esta pessoa?')) {
            return
        }
        try {
            show = true
            person = await window.api.events.persons.reactivate(person.personId)
            dispatch('close', person)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir esta pessoa?')) {
            return
        }
        try {
            show = true
            await service.remove(person.personId)
            dispatch('removed', null)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function sendClose() {
        console.log('send close')
        dispatch('close', person)
    }

    onMount(async () => {
        await loadCountries()
        await loadReferrals()
        if (person?.personId) {
            await editEntity(person.personId)
        } else {
            step = 2
        }
    })

    async function searchAddress() {
        const cleanCEP = person.CEP?.replace('-', '') || ''
        if (cleanCEP.length < 7 || cleanCEP.length > 8) {
            window.error('CEP inválido')
            return
        }
        try {
            const res = await cep(cleanCEP)
            if (!res) return
            console.log('address-found', res)
            person.address = res.street || person.address
            person.state = res.state || person.state
            person.city = res.city || person.city
            person.district = res.neighborhood || person.district
        } catch (error) {}
    }
</script>

<LoadSpinner {show} delay={0}></LoadSpinner>

{#if step === 1 && person}
    <div class="root">
        <Zact>
            {#if window.store.token.permissions.persons.persons.write}
                <div class="spacer" />
                {#if !!person.personId}
                    {#if person.status > 0}
                        <Zbutton color="red" icon={faTrashAlt} label="Excluir" on:click={removeEntity} />
                    {:else}
                        <Zbutton color="secondary" icon={faRotateLeft} label="Reativar" on:click={reactivateEntity} />
                    {/if}
                {/if}
                {#if !person?.personId || person?.status > 0}
                    <Zbutton color="primary" icon={faSave} label="Salvar" disabled={show} on:click={saveEntity} />
                {/if}
            {/if}
        </Zact>

        <Content>
            {#if person?.status === 0}
                <div class="sections">
                    <ZsheetSection label="Cadastro excluído" tone="danger">Este cadastro foi excluído. Reative-o para voltar a editar.</ZsheetSection>
                </div>
            {/if}

            <div class="sections">
                <ZsheetSection label="Dados básicos" meta={person.name ? '' : 'obrigatório'}>
                    <ZContainer gapRow="8px" gapCol="8px">
                        <Zinput size={6} sizeM={12} label="Nome do contato" type="text" autocomplete="off" bind:value={person.name} />
                        <Zinput size={6} sizeM={12} label="Celular" type="tel" autocomplete="off" bind:value={person.phone} />
                        <Zinput size={6} sizeM={12} label="E-mail" type="text" autocomplete="off" bind:value={person.email} />
                        <Zinput size={6} sizeM={12} label="Origem" type="select" options={referralOptions} bind:value={person.referralId} />
                        {#if window.featureFlags.includes('prospect')}
                            <Zinput size={6} sizeM={12} label="Nome da empresa" type="text" autocomplete="off" bind:value={person.businessName} />
                        {/if}
                    </ZContainer>
                </ZsheetSection>

                <!-- o resto do cadastro fica recolhido no celular: quem abre a ficha quase sempre quer
                 só nome e telefone -->
                <Zexpand {expand} label={expand ? 'Exibir menos' : 'Exibir mais'}>
                    <ZsheetSection label="Endereço">
                        <ZContainer gapRow="8px" gapCol="8px">
                            <Zinput
                                size={3}
                                sizeM={12}
                                label="CEP"
                                type="text"
                                autocomplete="off"
                                acts={[actBuscarCep]}
                                bind:value={person.CEP}
                                on:keyup={onCepKeyup}
                            />

                            <Zinput size={6} sizeM={12} label="Endereço" type="text" autocomplete="off" bind:value={person.address} />
                            <Zinput size={3} sizeM={4} label="Nº" type="text" autocomplete="off" bind:value={person.number} />
                            <Zinput size={3} sizeM={8} label="Complemento" type="text" autocomplete="off" bind:value={person.complement} />
                            <Zinput size={3} sizeM={12} label="Bairro" type="text" autocomplete="off" bind:value={person.district} />
                            <Zinput size={3} sizeM={8} label="Cidade" type="text" autocomplete="off" bind:value={person.city} />
                            <Zinput size={1} sizeM={4} label="UF" type="text" autocomplete="off" maxlength={2} bind:value={person.state} />
                            <Zinput size={2} sizeM={12} label="País" type="select" options={countryOptions} bind:value={person.country} />
                        </ZContainer>
                    </ZsheetSection>

                    <ZsheetSection label="Dados pessoais" class="h-space">
                        <ZContainer gapRow="8px" gapCol="8px">
                            <Zinput size={4} sizeM={12} label="CPF / CNPJ" type="text" autocomplete="off" bind:value={person.document} />
                            <Zinput size={4} sizeM={6} label="RG" type="text" autocomplete="off" bind:value={person.RG} />
                            <Zinput size={4} sizeM={6} label="Nº do passaporte" type="text" autocomplete="off" bind:value={person.passport} />
                            <Zinput size={4} sizeM={6} label="Nascimento" type="date" bind:value={bornDate} />
                            <Zinput size={4} sizeM={6} label="Sexo" type="select" options={genderOptions} bind:value={person.gender} />
                        </ZContainer>
                    </ZsheetSection>

                    <ZsheetSection label="Extra" class="h-space">
                        <ZContainer gapRow="8px" gapCol="8px">
                            <Zinput size={12} label="Anotações" type="textarea" rows={2} autocomplete="off" bind:value={person.comments} />

                            <Zinput size={3} skin="outline" label="Bloquear e-mails" type="toggle" bind:value={person.donotEmail} />
                            <Zinput size={3} skin="outline" label="Bloquear telefone" type="toggle" bind:value={person.donotPhone} />
                            <Zinput size={3} skin="outline" label="Bloquear SMS" type="toggle" bind:value={person.donotSms} />
                            <Zinput size={3} skin="outline" label="Bloquear WhatsApp" type="toggle" bind:value={person.donotWA} />
                            <Zinput size={3} skin="outline" label="Bloquear agendamento online" type="toggle" bind:value={person.donotLogin} />
                        </ZContainer>
                    </ZsheetSection>

                    <div class="rodape">
                        id: {person.personId || ''} · Cadastro: {dayjs(person.createdAt).format('DD/MM/YYYY HH:mm')}
                    </div>
                </Zexpand>
            </div>
        </Content>
    </div>
{:else if step === 2}
    <Content>
        <div class="sections">
            <ZsheetSection label="Novo contato">
                <ZContainer gapRow="8px" gapCol="8px">
                    <!-- "Avançar" mora dentro do campo: é a única ação desta etapa e segue o telefone -->
                    <Zinput
                        size={12}
                        label="Celular do novo contato"
                        type="tel"
                        autocomplete="off"
                        acts={[actAvancar]}
                        bind:value={phone}
                        on:keyup={onTelefoneKeyup}
                    />
                </ZContainer>
            </ZsheetSection>

            {#if duplicity}
                {#if window.configs.allowPersonDuplicity}
                    <ZsheetSection label="Telefone já cadastrado" tone="attention">
                        <div class="aviso">
                            Já existe uma pessoa cadastrada com este telefone: <b>{duplicity}</b>.<br />
                            Deseja mesmo criar um novo cadastro com o mesmo número?
                        </div>
                        <div class="aviso_acts">
                            <Zbutton color="secondary" label="Não" on:click={cancelDuplicity} />
                            <Zbutton color="primary" label="Sim, criar outro cadastro" on:click={allowDuplicity} />
                        </div>
                    </ZsheetSection>
                {:else}
                    <ZsheetSection label="Telefone já cadastrado" tone="danger">
                        <div class="aviso">
                            Já existe uma pessoa cadastrada com este telefone: <b>{duplicity}</b>.<br />
                            Se o telefone não pertence a ela, acesse aquele cadastro e remova o número primeiro. Depois você poderá cadastrar esta pessoa.
                        </div>
                    </ZsheetSection>
                {/if}
            {/if}
        </div>
    </Content>
{/if}

<style>
    /* pilha de blocos, a mesma linguagem das outras telas modernizadas */
    .sections {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin: 12px;
    }
    /* os interruptores ficam lado a lado enquanto couber, e quebram sozinhos no celular */
    .bloqueios {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 16px;
        margin-top: 8px;
    }
    .bloqueios :global(.zinput) {
        flex: 0 1 auto;
    }
    .rodape {
        font-size: 12px;
        opacity: 0.5;
        text-align: right;
        padding: 0px 4px;
    }
    .aviso {
        font-size: 14px;
        line-height: 1.5;
    }
    .aviso_acts {
        display: flex;
        gap: 8px;
        margin-top: 12px;
        justify-content: flex-end;
    }
</style>
